export const ALERT_TYPE = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};
